module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "wangbo-min.56f72d73.jpg";